module.exports = __webpack_public_path__ + "89c4f067b733c20ae06dd5f71edae950.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/image/GameOut/affinity/TshirtSmall.png
// module id = 556
// module chunks = 0